import React, { Fragment, useEffect, useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Alert} from "../../shared";
import {
  setDashboardMine,
  setZoneWidgets,
  setDashboardZone,
  setDashboardDetails,
  setDeviceMine,
  setSelectedZone,
} from "../../redux";
import "./right.css";
import { MainPageDesktop } from "./desktopView/MainPageDesktop";
import { MainPageMobile } from "./mobileView/MainPageMobile";
import {
  getTodayDate,
  dashboardMine,
  zoneWidgets,
  dashboardZone,
  deviceMineApi,
} from "../../api";
import Cookies, { set } from "js-cookie";
import { Widgets, Device } from "../../shared/DeviceWidgets";
import { WidgetSkeloton } from "../../shared/SkelotonScreen";
import { makeId } from "../../components/helpers";
import Paho from "paho-mqtt";
import { withRouter } from "react-router-dom";
import { FiEyeOff, FiEye, FiHardDrive, FiServer } from "react-icons/fi";
import { MqttConnection } from "../MqttConnection";
import i18n from "../../i18n/locales/config";
// import { DeviceMineContext } from "../../context/DeviceMineContext";

var hostname = "assessn.mmaviot.com";
var hostname = "assessn.mmaviot.com";
var port = 9999;
var user = "vertex";
var password = "TwZs5P4wJ6t85G8NtPQZ";
var topic_assess = "assess/device/";
var topic_control = "control/device/";
var reconnectTimeout = 1000;
var timeout = 1000;
const ERROR_HOST_DISCONNECTED = "connection lost";
const ERROR_HOST_UNREACHABLE = " connecting to server is impossible ";
const SUCCESS_HOST_CONNECTED = "connected to the server ";
const ALERT_HOST_CONNECTING = "connecting to server";
var clients = [];

const RightComp = (props) => {
  var connected = false;
  const { t } = useTranslation();
  const [isPhone, setIsPhone] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);
  const dispatch = useDispatch();
  const [showDevicsSection, setShowDevicsSection] = useState(true);
  const [today, setToday] = useState("");
  const token = Cookies.get("token");
  const zoneWidget = useSelector((state) => state.zoneWidgets.zoneWidgets);
  const selectedZone = useSelector((state) => state.selectedZone);
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const deviceMine = useSelector((state) => state.deviceMine.deviceMine);
  // const { deviceMine, setDeviceMine } = useContext(DeviceMineContext);
  // setDeviceMine(deviceMine1);
  const [health, setHealth] = useState({
    health: "",
    node: "",
    status: "",
  });
  let gadget2 = [];
  var i = 0;

  //for spaceing and scroll on devices//
  // useEffect(() => {
  //   const deviceSection = document.getElementById("devices");
  //   const devices = document.getElementsByClassName("device");
  //   let totalHeight = 0;
  //   for (let i = 0; i < devices.length; i++) {
  //     totalHeight += devices[i].clientHeight;
  //   }
  //   deviceSection.style.height = `${totalHeight}px`;
  // }, [deviceMine]);
  //end spaceing//
  useEffect(() => {
    var width = Math.max(window.screen.width, window.innerWidth);
    if (width <= 992) {
      setIsPhone(true);
    }

    getTodayDate(token)
      .then((res) => {
        // setToday(res.data.data);
        setToday(Date().slice(0, 11));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 5000);
        }
      });

    deviceMineApi(token)
      .then((res) => {
        const deviceData = res.data.data;
        dispatch(setDeviceMine(deviceData));
        var today = new Date();
        var time = today.getSeconds();
        deviceData.map((item, i) => {
          gadget2.push({
            id: item.id,
            active: true,
            time: time,
            widgets: null,
          });

          function connectDevice() {
            var client = new Paho.Client(hostname, Number(port), makeId(9));
            clients.push(client);
            client.onConnectionLost = onConnectionLost;
            client.onMessageArrived = onMessageArrived;
            client.connect({
              timeout: 3000,
              mqttVersion: 3,
              onSuccess: onSuccess,
              onFailure: onFailure,
              userName: item.user,
              password: item.password,
              useSSL: true,
              keepAliveInterval: 1000,
              reconnect: true,
            });

            function onSuccess() {
              connected = true;
              // console.log(SUCCESS_HOST_CONNECTED + item.caption);
              deviceData.map((v) => {
                setTimeout(() => {
                  if (!connected) {
                    console.log("Not connected to host: " + hostname);
                  } else {
                    client.subscribe(topic_assess + v.id);
                    client.subscribe(topic_control + v.id);
                  }
                }, timeout);
              });
            }

            function onFailure(e) {


              setShowAlert({
                show: true,
                message: t("عدم اتصال به سرور، لطفا اتصال خود را به اینترنت چک نموده و وی پی ان خود را خاموش نمایید، درصورتیکه مشکل برطرف نشد مرورگر خود را مجددا اجرا نمایید"),
                type: "Error",
              });


              // const mqtt = require("mqtt");

              // const client = mqtt.connect("mqtt://http://localhost:3000");
              // client.on("connect", () => console.log("connected", new Date()));
              // client.on("close", () => console.log("disconnected", new Date()));
              // client.on("error", (err) => console.error("error", err));

              // setTimeout(() => client.reconnect(), 5000);
              // client.connect(options);
              console.log("Connection Lost ... ");
              // console.log(ERROR_HOST_UNREACHABLE + item.caption + " " + hostname + "Failed! " +
              //     e.invocationContext + " Code: " + e.errorCode + " Message: " +
              //     e.errorMessage);
              // retrying
              setTimeout(connectDevice, 500);
            }
          }

          setTimeout(connectDevice, 500);
        });
      })
      .catch(() => {});

    dashboardMine(token)
      .then((res) => {
        dispatch(setDashboardMine(res.data.data));
        const formData = new FormData();
        formData.append("dashboard", res.data.data[0].id);
        dispatch(setDashboardDetails(res.data.data[0]));
        dashboardZone(formData, token)
          .then((res) => {
            dispatch(setSelectedZone(res.data.data[0].id));
            const zoneIdd = new FormData();
            zoneIdd.append("zone", res.data.data[0]["id"]);
            zoneWidgets(zoneIdd, token)
              .then((res) => {
                dispatch(setZoneWidgets(res.data.data));
              })
              .catch((err) => {
                setIsEmpty(true);
                if (err.response.status === 403) {
                  Cookies.remove("token");
                  props.history.push("/login");
                  setShowAlert((prevState) => ({
                    ...prevState,
                    show: true,
                    message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
                    type: "Error",
                  }));
                  setTimeout(() => {
                    setShowAlert((prevState) => ({
                      ...prevState,
                      show: false,
                    }));
                  }, 5000);
                }
              });
            dispatch(setDashboardZone(res.data.data));
          })
          .catch((err) => console.log(err));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 5000);
        }
      });
  }, []);

  function onConnectionLost(responseObject) {
    connected = false;

    // client.connect(options);
    // console.log(
    //   "onConnectionLost: " +
    //     ERROR_HOST_DISCONNECTED +
    //     " " +
    //     responseObject.errorMessage
    // );
  }

  function onMessageArrived(message) {
    //console.log("Message arrived: Topic=" + message.destinationName + ", Message=" + message.payloadString);
    //test
    var a = message.destinationName.split("/");
    if (a[0] == "assess") {
      var PowerManagementCalculator = message.payloadString.split(",");
      var PowerManagementCalculatorSplit =
        PowerManagementCalculator[2].split(":");
      // (PowerManagementCalculatorSplit[1])

      analyzeMessageAssess(
        message.payloadString,
        a[2],
        PowerManagementCalculatorSplit[1]
      );
    }
  }

  function analyzeMessageAssess(message, node, energy) {
    var today = new Date();
    var time = today.getSeconds();
    var _m = JSON.parse(message);
    gadget2.map((item, i) => {
      if (item.id === node) {
        item.time = time;
        item.widgets = _m.y;
      }
    });
    _m.y.forEach(function (v, i) {
      var exhibit = v == 1 || v == 2 || v == 5 ? "device-on" : "device-off";
      var elem = document.getElementById(`${node}index${i}`);
      var text = document.getElementById(`${node}text${i}`);
      if (elem !== null) {
        if (exhibit === "device-off") {
          elem.classList.remove("device-on");
          elem.classList.remove("device-desconnect");
          elem.classList.add(exhibit);
          if (text) {
            text.innerHTML = t("خاموش");
          }
        } else if (exhibit === "device-on") {
          elem.classList.remove("device-off");
          elem.classList.remove("device-desconnect");
          elem.classList.add(exhibit);
          if (!isNaN(energy)) {
            if (text && energy != "undefined") {
              text.style.fontSize = "11px";
              text.innerHTML = "power :" + Math.round(220 * energy) + "W";
            }
          } else {
            text.innerHTML = t("روشن");
          }
        }
      }
    });
    var span = document.getElementsByClassName(node);
    for (i = 0; i < span.length; i++) {
      span[i].classList.remove("dangerBorder");
      span[i].classList.add("successBorder");
    }
  }

  const sendWidgetCommand = (command, id) => {
    // console.log("Send Widget Command");
    var message = new Paho.Message(command);
    message.destinationName = topic_control + id;
    clients.map((client) => {
      client.send(message);
    });
  };

  const getDevices = () => {
    setViewIndex(2);
  };

  setInterval(() => {
    var today = new Date();
    var time = today.getSeconds();
    gadget2.map((item) => {
      if (time - item.time > 6) {
        var span = document.getElementsByClassName(item.id);
        for (i = 0; i < span.length; i++) {
          span[i].classList.add("dangerBorder");
          span[i].classList.remove("successBorder");
        }

        item.widgets?.map((v, i) => {
          var elem = document.getElementById(`${item.id}index${i}`);
          var text = document.getElementById(`${item.id}text${i}`);

          if (elem !== null) {
            elem.classList.remove("device-on");
            elem.classList.add("device-off");
            if (text) {
              text.innerHTML = t("خاموش");
            }
          }
        });
      }
    });
  }, 6000);
  const handleFa = () => {
    i18n.changeLanguage("fa");
  };

  return (
    <div>
      {!isPhone ? (
        <>
          <MainPageDesktop today={today} />
        </>
      ) : (
        <>
          <MainPageMobile
            today={today}
            showDevicsSection={showDevicsSection}
            setShowDevicsSection={setShowDevicsSection}
          />
        </>
      )}

      {showDevicsSection && (
        <div className="orient">
          <div className="d-flex my-4">
            <div className="w-100 px-3 my-2" style={{ height: "10vh" }}>
              <div className="d-flex align-items-center justify-content-between">
                <div className="text-right mt-2">
                  {zoneWidget?.map((item) => {
                    if (viewIndex === 0 && item.property[3] !== "0") {
                      i++;
                    } else if (viewIndex === 1) {
                      i = zoneWidget.length;
                    } else if (viewIndex === 2) {
                      i = deviceMine.length;
                    }
                  })}
                  <p className="m-0 fn14">
                    {selectedZone.zone_caption
                      ? selectedZone.zone_caption
                      : dashboardZones && dashboardZones[0]["zone_caption"]}
                  </p>
                  <small style={{ color: "#ADADAD", fontSize: "12px" }}>
                    {i} {viewIndex === 2 ? t("دستگاه") : t("ویجت")}
                  </small>
                </div>
                <div className="d-flex gap-2">
                  <i
                    className={`d-block widgetDisplayIcons cursor 
                    text-center  gap-2 
                  d-flex align-items-center justify-content-center
                    mx-1 
                    ${isPhone ? "rounded-circle phoneView" : "rounded-5"}
                                    ${
                                      viewIndex === 2
                                        ? "bg-priimary text-white"
                                        : "bg-white"
                                    }`}
                    onClick={getDevices}
                  >
                    <FiHardDrive />
                    {!isPhone && <span>{t("دستگاه ها")}</span>}
                  </i>
                  <i
                    className={`d-block widgetDisplayIcons cursor 
                    text-center  gap-2 
                  d-flex align-items-center justify-content-center
                    mx-1 
                    ${isPhone ? "rounded-circle phoneView" : "rounded-5"}
                                    ${
                                      viewIndex === 1
                                        ? "bg-priimary text-white"
                                        : "bg-white"
                                    } mx-1`}
                    onClick={() => setViewIndex(1)}
                  >
                    {viewIndex === 1 ? <FiEye /> : <FiEyeOff />}
                    {!isPhone && <span>{t("مشاهده")}</span>}
                  </i>
                  <i
                    className={`d-block widgetDisplayIcons cursor 
                                      text-center  gap-2 
                                    d-flex align-items-center justify-content-center
                                      mx-1 
                                      ${
                                        isPhone
                                          ? "rounded-circle phoneView"
                                          : "rounded-5"
                                      }
                                    ${
                                      viewIndex === 0
                                        ? "bg-priimary text-white"
                                        : "bg-white"
                                    }`}
                    onClick={() => setViewIndex(0)}
                  >
                    <FiServer />
                    {!isPhone && <span>{t("ویجت ها")}</span>}
                  </i>
                </div>
                
              </div>
            </div>


            



            
          </div>

          {/* ///////////////////////////////////////////////////// */}
          {viewIndex === 0 || viewIndex === 1 ? (
            <div
              className="text-right mt-3 p-1 devices d-flex flex-wrap"
              id="devices"
            >
              {zoneWidget?.length !== 0 ? (
                zoneWidget?.map((zone, index) => {
                  if (viewIndex === 0 && zone.property[3] !== "0") {
                    return (
                      <Widgets
                        key={index}
                        zone={zone}
                        health={health}
                        sendWidgetCommand={sendWidgetCommand}
                      />
                    );
                  } else if (viewIndex === 1) {
                    return (
                      <Widgets
                        key={index}
                        zone={zone}
                        showAll={true}
                        health={health}
                        sendWidgetCommand={sendWidgetCommand}
                      />
                    );
                  }
                })
              ) : (
                <>
                  {isEmpty && (
                    <>
                      <WidgetSkeloton />
                      <WidgetSkeloton />
                      <WidgetSkeloton />
                      <WidgetSkeloton />
                    </>
                  )}
                </>
              )}
              {viewIndex === 2
                ? deviceMine?.map((device, index) => {
                    return <Device device={device} key={index} />;
                  })
                : ""}
            </div>
          ) : (
            <div
              className="text-right mt-3 p-1 devices  d-flex justify-content-around flex-wrap"
              id="devices"
            >
              {viewIndex === 2
                ? deviceMine?.map((device) => {
                    return <Device device={device} />;
                  })
                : ""}

                
            </div>
          )}





        </div>
        
      )}


<div
  className="text-right mb-30 p-10 devices d-flex justify-content-around flex-wrap"
  style={{ position: 'absolute', zIndex: 1000, bottom: '30px' }} // تغییر position به absolute و افزایش z-index
>
  {showAlert.show && (
    <Alert 
      message={showAlert.message} 
      type={showAlert.type} 
    />
  )}
</div>


    </div>
    
    
  );
  
};

const Right = withRouter(RightComp);

export { Right };
